export default function Machines_D_0 (number = 1) {
  return {
    name: '制作台Mk.Ⅰ',
    icon: '/static/img/machines/d0.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_0.js